import React from "react";
import { Table } from "reactstrap";

import CartaoGrafico from "./CartaoGrafico";
import useResumoDespacho from "./useResumoDespacho";

// Situação dos lotes de despacho no período (PO1-3494): despachados, abertos,
// fechados sem despacho e a origem do fechamento (manual / gatilho por horário /
// gatilho por volume). Números, não gráfico: são 6 valores que se leem de uma vez.

const fmtNumero = (v) => (v === null || v === undefined ? "-" : Number(v).toLocaleString("pt-BR"));

export function linhasLotes(lotes) {
  if (!lotes) return [];
  const origem = lotes.porOrigem || {};
  return [
    { rotulo: "Despachados", valor: lotes.despachados, destaque: true },
    { rotulo: "Abertos", valor: lotes.abertos },
    { rotulo: "Fechados sem despacho", valor: lotes.fechadosSemDespacho },
    { rotulo: "Fechamento manual", valor: origem.manual, grupo: "Origem" },
    { rotulo: "Gatilho por horário", valor: origem.horario, grupo: "Origem" },
    { rotulo: "Gatilho por volume", valor: origem.volume, grupo: "Origem" },
  ];
}

export function TabelaSituacao({ linhas, ariaLabel }) {
  return (
    <Table size="sm" borderless className="despacho-situacao" aria-label={ariaLabel}>
      <tbody>
        {linhas.map((l, i) => {
          const abreGrupo = l.grupo && (i === 0 || linhas[i - 1].grupo !== l.grupo);
          return (
            <React.Fragment key={l.rotulo}>
              {abreGrupo ? (
                <tr>
                  <td colSpan={2} style={{ paddingTop: 12, fontSize: 11, textTransform: "uppercase", opacity: 0.7 }}>
                    {l.grupo}
                  </td>
                </tr>
              ) : null}
              <tr>
                <td>{l.rotulo}</td>
                <td style={{ textAlign: "right", fontWeight: l.destaque ? 700 : 400, fontSize: l.destaque ? 18 : 14 }}>{fmtNumero(l.valor)}</td>
              </tr>
            </React.Fragment>
          );
        })}
      </tbody>
    </Table>
  );
}

export default function LotesSituacao({ deferLoad = false, onRegisterFetch }) {
  const { dados, carregando, erro } = useResumoDespacho({ deferLoad, onRegisterFetch });
  const linhas = linhasLotes(dados && dados.lotes);

  return (
    <CartaoGrafico titulo="Lotes" subtitulo="Lotes de despacho do período, por situação e origem do fechamento" carregando={carregando} erro={erro} vazio={!linhas.length}>
      <TabelaSituacao linhas={linhas} ariaLabel="Situação dos lotes" />
    </CartaoGrafico>
  );
}
